import { TextArea } from "@/components/field";

type InstructionsPanelProps = {
  isDisabled: boolean;
  onChange: (value: string) => void;
  value: string;
};

export function InstructionsPanel({
  isDisabled,
  onChange,
  value,
}: InstructionsPanelProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <label
        className="text-[13px] font-bold text-text-tertiary"
        htmlFor="alpha-instructions"
      >
        Anything else? (optional)
      </label>
      <TextArea
        className="min-h-16 resize-none text-[15px] leading-[21px]"
        disabled={isDisabled}
        id="alpha-instructions"
        onChange={(event) => onChange(event.target.value)}
        rows={2}
        value={value}
      />
    </div>
  );
}
